// extracted by mini-css-extract-plugin
export var bannerSection = "Banner-module--bannerSection--4pc-+";
export var banner = "Banner-module--banner--1PDPX";
export var banner_gradient = "Banner-module--banner_gradient--G7LMW";
export var banner__image = "Banner-module--banner__image--l1JEj";
export var banner__content = "Banner-module--banner__content--2us-q";
export var banner__content__title = "Banner-module--banner__content__title--jgKR-";
export var banner__content_withLogo = "Banner-module--banner__content_withLogo--F0e-a";
export var banner__content__logo = "Banner-module--banner__content__logo--UtjxN";